import script from "./LegalDocsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalDocsPage.vue?vue&type=script&setup=true&lang=js"

import "./LegalDocsPage.vue?vue&type=style&index=0&id=9fc55f52&scoped=true&lang=css"
import "./LegalDocsPage.vue?vue&type=style&index=1&id=9fc55f52&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fc55f52"]])

export default __exports__